import React from "react";
// import Carousel from "react-material-ui-carousel";
import { styled } from "@mui/material";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Paper, Button, Box, Typography, Skeleton } from "@mui/material";
import Crousel_1 from "../../../assets/customerAssets/crousel_1.png";
import Crousel_2 from "../../../assets/customerAssets/crousel_2.png";
import Crousel_3 from "../../../assets/customerAssets/crousel_3.png";
import Crousel_4 from "../../../assets/customerAssets/crousel_4.png";
import Crousel_sub_1 from "../../../assets/customerAssets/crousel_sub_1.png";
import Crousel_sub_2 from "../../../assets/customerAssets/crousel_sub_2.png";
import Crousel_sub_3 from "../../../assets/customerAssets/crousel_3_sub.png";
import Crousel_sub_4 from "../../../assets/customerAssets/crousel_4_sub.png";
import WinnerIcon from "../../../assets/customerAssets/winnerIcon.svg";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import GuestUserRistModal from "../../Modals/user/guestUserModalRist/Modal";

const Carousel_head_2 = styled(Typography)({
  fontFamily: "Barlow Condensed",
  fontStyle: "italic",
  fontWeight: "700",
  fontSize: "18px",
  lineHeight: "22px",
  letterSpacing: "0.01em",
  textTransform: "uppercase",

  color: "#FFFFFF",
});

let crousel_items = [
  {
    head: "Random Name #1",
    subHead: "Probably the most random thing you have ever seen!",
    img: Crousel_1,
    subImg: Crousel_sub_1,
  },
  {
    head: "Random Name #1",
    subHead: "Probably the most random thing you have ever seen!",
    img: Crousel_2,
    subImg: Crousel_sub_1,
  },

  {
    head: "Random Name #1",
    subHead: "Probably the most random thing you have ever seen!",
    img: Crousel_3,
    subImg: Crousel_sub_1,
  },

  {
    head: "Random Name #1",
    subHead: "Probably the most random thing you have ever seen!",
    img: Crousel_4,
    subImg: Crousel_sub_1,
  },
];

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 2,
    slidesToSlide: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
    slidesToSlide: 2,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    slidesToSlide: 1,
  },
};

function Crousel(props) {
  const navigate = useNavigate();
  const carousel = useSelector((state) => state.carousel);
  const loggedUser = useSelector((state)=>state.loggedUser.user);
  const [openGuestRistModal , setOpenGuestRistModal] = React.useState(false);

  const handleNavigate = (banner) => {
    if (!banner.isProfessionalTournament) {
      const id = banner.bannerCategory.id;
      const bannerName = banner.bannerCategory.name;
      const bannerType = banner.type;
      if(loggedUser.device_id){
        // navigate("/login");
        // return ;
        setOpenGuestRistModal(true);
        return ;
      }

      if (banner.bannerCategory.name == "My Club/Tournament") {
        navigate("/addTournament");
      } else if (banner.bannerCategory.name == "Football Skills Challenge") {
        navigate("/addChallenge");
      } else if (banner.bannerCategory.name == "Youth Football") {
        navigate(`/leaderboards/${bannerName}/${bannerType}`);
      } else {
        navigate(`/leaderboards/${bannerName}/${bannerType}`);
      }
    } else {
      navigate(`/professional-tournament/${banner.id}`);
    }
  };

  return (
    <>
    
    <Box className="crousel-wrapper">
      <Carousel
        autoPlay={true}
        // autoPlay={false}
        autoPlaySpeed={3000}
        transitionDuration={1500}
        swipeable={false}
        draggable={false}
        showDots={false}
        ssr={true}
        infinite={true}
        responsive={responsive}
        centerMode={true}
        arrows={true}
        sliderClass="crouset-slider"
        itemClass="crousel-item"
      >
        {carousel.loading ? (
          Array.from({ length: 5 }).map((_, i) => (
            <Skeleton
              sx={{ height: "250px" }}
              animation="wave"
              variant="rectangular"
              key={i}
            />
          ))
        ) : Array.isArray(carousel?.data?.data) &&
          carousel.data.data.length > 0 ? (
          carousel.data.data.map((data) => (
            <Paper
              sx={{
                backgroundImage: `url(${data.banner_img})`,
              }}
              className="crouselItem"
              onClick={() => handleNavigate(data)}
              key={data.id || data.banner_img}
            ></Paper>
          ))
        ) : (
          <div>No data available</div>
        )}
      </Carousel>
    </Box>
    <GuestUserRistModal open={openGuestRistModal} setOpen={setOpenGuestRistModal} />
    </>
  );
}


export default Crousel;
